<template>
  <a-modal
    :title="title || '导入'"
    :visible="visibleModal"
    :confirm-loading="confirmLoading"
    width="448px"
    wrapClassName="import-modal"
    @ok="handleUpload"
    @cancel="importModalhandleCancel"
    okText="提交"
  >
    <div class="first-step">
      <p class="step-title">{{ `第一步：下载${title || ""}模板` }}</p>
      <div class="export_step_box">
        <img src="@/assets/images/export.png" alt="" />
        {{ templateFileInfo.desc || "" }}
        <a
          :href="templateFileInfo.fileUrl"
          :download="`${templateFileInfo.desc || '模版'}.xlsx`"
          class="downloag_btn"
          @click="dowmLoadFun"
          >点击下载<a-icon type="arrow-down"
        /></a>
      </div>
      <div class="second-step">
        <p class="step-title">第二步：上传编辑好的Excle表格</p>
        <a-upload-dragger
          name="file"
          accept=".xls,.xlsx"
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          :multiple="false"
          :fileList="fileList"
          :remove="handleRemove"
          :before-upload="beforeUpload"
          @change="handleChange"
        >
          <img class="upload_img" src="@/assets/images/export.png" alt="" />
          <div class="upload_text">点击或将文件拖拽到这里上传</div>
        </a-upload-dragger>
      </div>
    </div>
  </a-modal>
</template>

<script>
import api from "../../../commomFun/api.js";

export default {
  props: {
    title: {
      type: String,
      default: () => "--"
    },
    visibleModal: {
      type: Boolean,
      default: () => false
    },
    fileLength: {
      type: Number,
      default: 1
    },
    templateFileInfo: {
      type: Object
    },
    requestConfig: {
      required: true
    }
  },
  data() {
    return {
      confirmLoading: false,
      fileList: []
    };
  },
  watch: {
    visibleModal(val) {
      if (val) {
        this.confirmLoading = false;
        this.fileList = [];
      }
    }
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    // 控制上传文件数量
    handleChange() {
      if (this.fileList.length > (this.fileLength || 1)) {
        this.fileList.shift();
      }
    },
    // 手动上传文件
    handleUpload() {
      const { fileList } = this;
      if (fileList.length === 0) {
        this.$message.warning("您还没有上传文件哦~");
        return;
      }
      const formData = new FormData();
      fileList.forEach(file => {
        formData.append("file", file);
      });
      let params = this.requestConfig.params || {};
      for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
          formData.append(key, params[key]);
        }
      }
      this.confirmLoading = true;
      api
        .postApi_file(this.requestConfig.url, formData)
        .then(res => {
          if (res.data.code == 200) {
            let resData = res.data.data;
            const h = this.$createElement;
            this.$success({
              title: `${this.title}完成`,
              content: h("div", {}, [
                h("span", "成功导入 "),
                h(
                  "span",
                  { style: { color: "#1890FF" } },
                  resData.successSize || "0"
                ),
                h("span", " 条，重复 "),
                h(
                  "span",
                  { style: { color: "#FAAD14" } },
                  resData.repeatSize || "0"
                ),
                h("span", " 条，失败 "),
                h(
                  "span",
                  { style: { color: "#F5222D" } },
                  resData.failSize || "0"
                ),
                h("span", " 条")
              ]),
              okText: "好 的"
            });
            this.importModalhandleCancel();
            this.$emit("successCallback");
          } else {
            this.$message.error(res.data.msg || "导入失败！");
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    // 导入模版下载, 阻止冒泡事件
    dowmLoadFun(event) {
      event.stopPropagation();
    },
    importModalhandleCancel() {
      this.$emit("update:visibleModal", false);
    }
  }
};
</script>

<style scoped lang="scss">
.upload_img {
  width: 26px;
  height: 26px;
}

/deep/ .import-modal {
  .step-title {
    margin-bottom: 16px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
  }

  .export_step_box {
    margin-bottom: 24px;
    border: 1px solid rgba(218, 218, 218, 1);
    border-radius: 4px;
    padding: 12px 18px;
    color: rgba(102, 102, 102, 1);
    font-size: 15px;
    position: relative;
    &:hover {
      cursor: pointer;
      border-color: #409eff;
    }
    img {
      margin-right: 8px;
      width: 26px;
      height: 26px;
      vertical-align: middle;
    }
    .downloag_btn {
      position: absolute;
      right: 18px;
      top: 50%;
      cursor: pointer;
      transform: translateY(-50%);
      color: rgba(102, 102, 102, 1);
    }
  }
  .second-step {
    .upload_img {
      margin: 16px 0 12px 0;
    }
    .upload_text {
      margin-bottom: 16px;
    }
  }
}
</style>
